import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import TiptapEditor from '../rte/TiptapEditor';

const RteWrapper = styled.div`
  height: 100%;
  width: 100%;
  text-align: left;
`;

const PricingTableFieldDescriptionCell = ({
  cell,
  columnIndex,
  columnId,
  rowIndex,
  onCellChange,
  onCellBlur,
  isEditable = true,
  fontSize,
  fontColor,
  fontStyle,
  fontWeight,
  textAlign,
  textTransform,
  textDecoration,
  backgroundColor,
  padding
}) => {

  return (
    <RteWrapper key={`tiptap-${rowIndex}-${columnIndex}-${columnId}`}>
      <TiptapEditor
        content={cell.value}
        disabled={!isEditable}
        onUpdate={(rte) => {
          onCellChange(rte);
        }}
        onBlur={() => {
          onCellBlur(true);
        }}
        hideMenu
        fontSize={fontSize}
        fontColor={fontColor}
        fontStyle={fontStyle}
        fontWeight={fontWeight}
        textAlign={textAlign || 'left'}
        textTransform={textTransform}
        textDecoration={textDecoration}
        backgroundColor={backgroundColor || 'transparent'}
        padding={padding ? `${padding}px` : '8px 8px 0 8'}
        paddingBottom={0}
        paddingTop={0}
        height="100%"
        width="100%"
      />
    </RteWrapper>
  );
};

export default PricingTableFieldDescriptionCell;

PricingTableFieldDescriptionCell.propTypes = {
  cell: PropTypes.shape({
    _id: PropTypes.string,
    value: PropTypes.any
  }),
  columnIndex: PropTypes.number.isRequired,
  columnId: PropTypes.string.isRequired,
  rowIndex: PropTypes.number.isRequired,
  onCellChange: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
  // Style props
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontColor: PropTypes.string,
  fontStyle: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  textDecoration: PropTypes.string,
  backgroundColor: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

